import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import c from 'classnames';
import useDiscountPrice from '../utils/hooks/useDiscountPrice';
import { formatDollars, OPTIONAL_DECIMAL_DIGITS } from '../utils/formatting';
import DiscountLabel from '../DiscountLabel';
import s from './PriceWithDiscount.scss';
const formatDollarsOptions = _object_spread_props(_object_spread({}, OPTIONAL_DECIMAL_DIGITS), {
    useGrouping: true
});
const PriceWithDiscount = ({ className, prefix, dollarAmount, eligibleDiscount, opaque })=>{
    const { price, discountedPrice } = useDiscountPrice(dollarAmount, eligibleDiscount);
    const formattedDollarAmount = formatDollars(price, formatDollarsOptions);
    const formattedDollarAmountAfterDiscount = formatDollars(discountedPrice, formatDollarsOptions);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, eligibleDiscount && /*#__PURE__*/ React.createElement(React.Fragment, null, prefix && /*#__PURE__*/ React.createElement("div", {
        className: s['prefix']
    }, prefix), /*#__PURE__*/ React.createElement("div", {
        className: s['price']
    }, formattedDollarAmountAfterDiscount), /*#__PURE__*/ React.createElement("div", {
        className: s['old-price']
    }, formattedDollarAmount), /*#__PURE__*/ React.createElement(DiscountLabel, {
        className: s['discount-label'],
        discount: eligibleDiscount,
        opaque: opaque
    })), !eligibleDiscount && /*#__PURE__*/ React.createElement("div", {
        className: s['price']
    }, formattedDollarAmount));
};
PriceWithDiscount.displayName = 'PriceWithDiscount';
export default PriceWithDiscount;

//# sourceMappingURL=PriceWithDiscount.js.map